export var E_AUTH_ACTION_TYPES;
(function (E_AUTH_ACTION_TYPES) {
    E_AUTH_ACTION_TYPES["FETCH_PERMISSIONS_REQUESTED"] = "FETCH_PERMISSIONS_REQUESTED";
    E_AUTH_ACTION_TYPES["FETCH_PERMISSIONS_SUCCEEDED"] = "FETCH_PERMISSIONS_SUCCEEDED";
    E_AUTH_ACTION_TYPES["FETCH_GROUP_REQUESTED"] = "FETCH_GROUP_REQUESTED";
    E_AUTH_ACTION_TYPES["FETCH_GROUP_SUCCEEDED"] = "FETCH_GROUP_SUCCEEDED";
    E_AUTH_ACTION_TYPES["USER_LOGIN_REQUESTED"] = "USER_LOGIN_REQUESTED";
    E_AUTH_ACTION_TYPES["USER_LOGIN_SUCCEEDED"] = "USER_LOGIN_SUCCEEDED";
    E_AUTH_ACTION_TYPES["USER_LOGOUT_REQUESTED"] = "USER_LOGOUT_REQUESTED";
    E_AUTH_ACTION_TYPES["USER_LOGOUT_SUCCEEDED"] = "USER_LOGOUT_SUCCEEDED";
})(E_AUTH_ACTION_TYPES || (E_AUTH_ACTION_TYPES = {}));
